var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMultiplaEscolha = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05273 7.7369L8.57905 10.2632L17.0001 1.84216",
    stroke: "#4B4E5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 8.57895V14.4737C16.1579 14.9204 15.9805 15.3487 15.6646 15.6646C15.3487 15.9805 14.9204 16.1579 14.4737 16.1579H2.68421C2.23753 16.1579 1.80914 15.9805 1.49329 15.6646C1.17744 15.3487 1 14.9204 1 14.4737V2.68421C1 2.23753 1.17744 1.80914 1.49329 1.49329C1.80914 1.17744 2.23753 1 2.68421 1H11.9474",
    stroke: "#4B4E5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMultiplaEscolha, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/multipla-escolha.e381cdf6.svg";
export { ForwardRef as ReactComponent };